// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cal.generic-dmg-cal .result label {\n  display: block;\n  margin: 10px 0;\n}\n.cal.generic-dmg-cal .result label span.dice-name {\n  font-size: 20px;\n  font-weight: 400;\n}\n.cal.generic-dmg-cal .result label input {\n  margin: 10px auto 0;\n}\n", ""]);
// Exports
module.exports = exports;
